const angular = require('angular');
const app = angular.module('learn-directives');

import React from 'react';
import { createRoot } from 'react-dom/client';
import PopupSurveyLayout from '../popup-survey-app';

const layoutVars = {
  survey: null,
  companyBranding: null,
  completeFn: null,
  expandSurvey: null,
  userLanguage: null,
};

function renderLayout(root, layoutVars) {
  const allPropsLoaded = !!(
    layoutVars.survey &&
    layoutVars.companyBranding &&
    layoutVars.completeFn &&
    layoutVars.expandSurvey !== null &&
    layoutVars.userLanguage
  );
  root.render(
    <div>
      { 
        allPropsLoaded &&
        <PopupSurveyLayout
        survey={layoutVars.survey}
        companyBranding={layoutVars.companyBranding}
        completeFn={layoutVars.completeFn}
        expandSurvey={layoutVars.expandSurvey}
        userLanguage={layoutVars.userLanguage}
        />
      }
    </div>
  );
}

const popupSurveyDirective = app.directive('popupSurveyDirective', [
  function () {
    return {
      template: `<div id="popup-survey-app" class="react-part"></div>`,
      scope: {
        survey: '=',
        companyBranding: '<',
        completeFn: '=',
        expandSurvey: '=',
        userLanguage: '<'
      },
      link: function (scope, el, attrs) {
        const reactapp = document.getElementById("popup-survey-app");
        const root = createRoot(reactapp);

        scope.$watch(
          'survey',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.survey = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'companyBranding',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.companyBranding = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'completeFn',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.completeFn = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'expandSurvey',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.expandSurvey = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'userLanguage',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.userLanguage = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );
      },
    };
  },
]);

export default popupSurveyDirective;